import {autoserializeAs, inheritSerialization} from "dcerialize";
import type {Existing, IdentifiableModel, IdOf, New} from "../base/IdentifiableModel";
import {createExisting, createNew} from "../base/IdentifiableModel";
import type {ModificationTrackedModel} from "../base/ModificationTrackedModel";
import type {SoftDeletableModel} from "../base/SoftDeletableModel";
import {ModificationDetails} from "../ModificationDetails";

export class IdOnlyCustomerOrganization implements IdentifiableModel {
  @autoserializeAs(() => Number)
  public id?: number;

  public static existing(id: IdOf<IdOnlyCustomerOrganization>): Existing<IdOnlyCustomerOrganization> {
    return createExisting(IdOnlyCustomerOrganization, id);
  }
}

@inheritSerialization(() => IdOnlyCustomerOrganization)
export class WritableCustomerOrganization extends IdOnlyCustomerOrganization {
  @autoserializeAs(() => String)
  public name: string;
  @autoserializeAs(() => Boolean)
  public isActive: boolean;

  public static createNew(name: string): New<WritableCustomerOrganization> {
    const org = createNew(WritableCustomerOrganization);
    org.name = name;
    org.isActive = true;
    return org;
  }
}

@inheritSerialization(() => WritableCustomerOrganization)
export class SimpleCustomerOrganization extends WritableCustomerOrganization implements SoftDeletableModel {
  @autoserializeAs(() => Boolean)
  public readonly isDeleted: boolean;
}

@inheritSerialization(() => SimpleCustomerOrganization)
export class CustomerOrganization extends SimpleCustomerOrganization implements ModificationTrackedModel {
  @autoserializeAs(() => Number)
  public readonly locationCount: number;
  @autoserializeAs(() => ModificationDetails)
  public readonly modificationDetails?: ModificationDetails;
}
